export function adaptFacetStats(meiliFacetStats) {
    const facetStats = Object.keys(meiliFacetStats).reduce((stats, facet) => {
        stats[facet] = { ...meiliFacetStats[facet], avg: 0, sum: 0 }; // Set at 0 as these numbers are not provided by Meilisearch
        return stats;
    }, {});
    return facetStats;
}
//# sourceMappingURL=adapt-facet-stats.js.map